import { Link } from 'react-router-dom';

type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-xs text-secondary-500">
      <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center text-secondary-400"></i>
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700 whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}